import { ContainerFooter } from './styles';

interface ContainerFooterProps {
  children: React.ReactNode;
}
export const AContainerFooter: React.FC<ContainerFooterProps> = ({
  children,
}) => {
  return <ContainerFooter>{children}</ContainerFooter>;
};
